'use strict';

var _ = require('lodash');
var PrintService = function PrintService($window, $rootScope, $timeout) {
  function print(gridId, gridContent) {
    var newWindow = $window.open('', '', 'scrollbars=1, width=800, height=500');
    if (newWindow) {
      var compiled = _.template(require('../templates/print-document-template.html'));
      var pageContent = compiled({
        'gridId': gridId,
        'gridContent': gridContent
      });
      var popup = newWindow.document.open();
      popup.write(pageContent);
      $rootScope.$broadcast('loading:progress');
      $timeout(function () {
        newWindow.document.close();
        newWindow.focus();
        newWindow.print();
        newWindow.close();
        $rootScope.$broadcast('loading:finish');
      }, 0);
    }
  }
  return {
    print: print
  };
};
PrintService.$inject = ['$window', '$rootScope', '$timeout'];
module.exports = PrintService;